//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'qrCoupon',
  components: {
    
  },
  data () {
    return {
      popUp:false,
      popUp1:false,
      popUp2:false,
      qrcode:'',
      code:'',
      codeOld:'',
      washCode:'',
      qrText:'',
      part:'',
      list:[],
      number:'',
      info:{},
    }
  },
   created(){
    if(this.$func.getLocal('token')){
      this.getInfo();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  methods:{
    async generateQRCode(text) {
      await this.$func.createQrCode(text,this.$refs.qrcodeCanvas);
      this.qrText = text;
      this.popUp = true;
      this.popUp1 = true;
      console.log('二维码生成完成')
    },
    getInfo(){
      this.$api.getInfo({}).then((res)=>{
        if(res){
          if(!Number(res.data.cid)){
              this.$router.push({path:'/login'})
              return false;
          }
          this.info = res.data;
          this.code = this.info.bag_code;
        }
      })
    },
    submit(){
      this.codeOld = this.code;
      let str = this.code.substr(0, 1);
      let part = this.code.substr(1,10);
      let len = part.length;
      let i = 0;
      let bagCode = '';
      this.list = [];
      while(i <= this.number){
        bagCode = (Number(part)+i).toString();
        bagCode = str+''+(bagCode.padStart(len,'0'));
        if(i < this.number){
          this.list.push(bagCode);
        }
        i++;
      }
      this.code = bagCode;
      this.washCode = bagCode;
      this.editWashCode();
      console.log('list',this.list);
    },
    export1(){
      if(this.number <= 0){
        this.$func.showToast('请输入生成数量');
        return false;
      }
      this.$func.startLoading('导出中...');
      this.$api.exportWashCode({code:this.codeOld,number:this.number}).then((res)=>{
        if(res){
          this.$func.endLoading();
          let path = res.data.path;
          this.$func.downloadFile(path,res.data.fileName)
          this.$func.showToast('导出成功');
        }
      })  
    },
    editWashCode(){
      if(!this.washCode){
        this.$func.showToast('请输入洗衣码');
        return false;
      }
      let str = this.washCode.substr(0, 1);
      var code = str != this.part ? this.part +''+ this.washCode : this.washCode;
      this.$api.editWashCode({code:code}).then((res)=>{
        if(res){
          this.code = code;
          // this.$func.showToast('修改成功');
          this.closePop();
        }
      })  
    },
    closePop(){
        this.popUp = false;
        this.popUp1 = false;
        this.popUp2 = false;
    },
    editBag(){
      this.part = this.code.substr(0,1);
      this.washCode = this.code.substr(1,10);
      this.popUp = true;
      this.popUp2 = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/washBagCode.vue